import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manageobjects',
  templateUrl: './manageobjects.component.html',
  styleUrls: ['./manageobjects.component.css']
})
export class ManageobjectsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
